import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

const UploadPageTitle = ({ uploadPage }) => {
  const intl = useIntl();
  const workspaceName = uploadPage.client.name || uploadPage.client.domain;

  return (
    <div className="upload-page-header">
      {uploadPage.title && (
        <h2 className="upload-title">
          {uploadPage.title}
        </h2>
      )}
      {workspaceName && (
        <p className="upload-overtitle">
          {intl.formatMessage({ defaultMessage: '{workspaceName} requested files to be uploaded into:' }, {
            workspaceName,
          })}
        </p>
      )}
      <h3 className="upload-title">
        {uploadPage.collection?.name}
      </h3>
      {uploadPage.description && (
        <div className="upload-subtitle">
          {uploadPage.description}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  uploadPage: state.UploadPages.uploadPage,
});

UploadPageTitle.propTypes = {
  uploadPage: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(UploadPageTitle);
